import { Measurements } from '~/utility/BinSentry-ui-utility';
import moment from 'moment';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { bannerStyles } from '../../styles/banner-styles';
import '../../common/bn-icon';
import '../../common/bn-loading';
import '../../common/bn-property';
import '../../devices/props/device-serial-number';
import '../../devices/props/device-event-payload-type';
import { FIRMWARE_MODE } from '../../devices/props/device-firmware-mode';

class WorkOrderDeviceStatus extends LitEntity {
  static get properties() {
    return {
      latestEvent: { type: Object, attribute: false },
      latestEventHref: { type: String, attribute: false },
      latestEventIsFresh: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      bn-icon {
        margin: 0 .3em;
      }
      .old {
        color: var(--red-20);
      }
      bn-property {
        padding: .2rem 0;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }
    if (!this.entity) {
      return html`
        <div class="banner banner--warning">
          <bn-icon name="far fa-exclamation-circle"></bn-icon>
          No Device Information Available.
        </div>
      `;
    }
    return html`
      <bn-property label="Serial Number">
        <device-serial-number .href="${this.href}"></device-serial-number>
      </bn-property>

      <h4>Latest Reading</h4>
      ${this._renderEventWarning()}
      ${this._renderLatestEvent()}
      <lit-entity .href="${this.latestEventHref}" @update="${this._onUpdateEvent}"></lit-entity>
    `;
  }

  _renderEventWarning() {
    return this.latestEventIsFresh ? html`` : html`
      <div class="banner banner--critical">
        <bn-icon name="far fa-exclamation-circle"></bn-icon>
        <strong>Warning:</strong>
        There have been no readings from this device in the last 5 minutes.
      </div>
    `;
  }

  _renderLatestEvent() {
    if (!this.latestEvent) {
      return html``;
    }
    const { has3DSensor, firmwareMode } = this.entity.properties;
    const ignoreErrors = has3DSensor && firmwareMode?.reported === FIRMWARE_MODE.SETUP;
    const dimension = Measurements.get('dimension');
    const { distance, date, cellStrength, batVolt, payloadType, networkOperator, sensorCriticalError, lastRunError } = this.latestEvent?.properties || {};
    return html`
      <bn-property label="Date">
        ${moment(date).fromNow()}
      </bn-property>
      <bn-property label="Distance">
        ${has3DSensor ? 'N/A' : html`${dimension.convert({ dimension: distance / 100 })} ${dimension.unit}`}
      </bn-property>
      <bn-property label="Cell Strength (dBm)">
        ${cellStrength}
      </bn-property>
      <bn-property label="Battery (V)">
        ${batVolt}
      </bn-property>
      <bn-property label="Type">
        <device-event-payload-type payload-type="${payloadType}"></device-event-payload-type>
      </bn-property>
      <bn-property label="Network">
        ${networkOperator}
      </bn-property>
      <bn-property label="Status">
        ${lastRunError?.title || ''}
      </bn-property>
      <bn-property label="Error">
        ${ignoreErrors ? 'N/A' : (sensorCriticalError?.title || 'none')}
      </bn-property>
    `;
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    this.latestEventHref = this.getHref('https://api.binsentry.com/rel/event-latest');
  }

  async _onUpdateEvent(e) {
    const { entity: latestEvent } = e.detail;
    const isFresh = latestEvent && moment(latestEvent.properties.date).isAfter(moment().subtract(5, 'minutes'));
    this.latestEventIsFresh = isFresh;
    this.latestEvent = latestEvent;
    this.dispatchEvent(new CustomEvent('event', { detail: { event: latestEvent, isFresh } }));
  }
}

window.customElements.define('work-order-device-status', WorkOrderDeviceStatus);
